import { useContext } from "react";
import AuthContext, { IAuthContext } from "../store/auth/AuthProvider";

const useAuth = () => {
  return useContext<IAuthContext>(AuthContext);
};

export default useAuth;
